export default "__VITE_ASSET__6172a147__"